export default function OrderStepsSection() {
  const steps = [
    {
      number: '01',
      title: 'LINEで友達追加・お問い合わせ',
      description: 'まずはLINEで友達追加。お気軽にご相談ください。',
      icon: 'ri-line-fill',
    },
    {
      number: '02',
      title: 'ヒアリング・デザイン打ち合わせ',
      description: 'ご希望のデザインやイメージをお聞かせください。プロのデザイナーがご提案します。',
      icon: 'ri-discuss-line',
    },
    {
      number: '03',
      title: 'ご購入・お支払い',
      description: 'デザイン確定後、銀行振込にてお支払いいただきます。',
      icon: 'ri-secure-payment-line',
    },
    {
      number: '04',
      title: '発送',
      description: 'お支払い確認後、営業日5日以内に発送いたします。',
      icon: 'ri-truck-line',
    },
  ];

  return (
    <section id="order-steps" className="py-16 md:py-24 bg-gradient-to-b from-black to-purple-950/20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 md:mb-6">
            オーダー方法
          </h2>
          <p className="text-base md:text-xl text-gray-300">
            簡単4ステップでオリジナルシャンパンが完成
          </p>
        </div>

        {/* モバイル: 縦並び / PC: 横4列 */}
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8 mb-10 md:mb-12">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-gradient-to-br from-purple-900/30 to-black/50 rounded-2xl md:rounded-3xl p-5 md:p-8 border border-purple-500/20 hover:border-yellow-400/50 transition-all duration-500 h-full">
                <div className="text-4xl md:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-200 mb-3 md:mb-4">
                  {step.number}
                </div>
                <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-xl md:rounded-2xl flex items-center justify-center mb-4 md:mb-6 shadow-lg">
                  <i className={`${step.icon} text-2xl md:text-3xl text-black`}></i>
                </div>
                <h3 className="text-sm md:text-xl font-bold text-white mb-2 md:mb-4 leading-tight">{step.title}</h3>
                <p className="text-gray-300 leading-relaxed text-xs md:text-base">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-4xl text-yellow-400/50"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="https://line.me/R/ti/p/@ula6319m?oat_content=url"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#06C755] hover:bg-[#05b34c] text-white text-base md:text-lg font-bold px-8 md:px-10 py-3 md:py-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-line-fill text-xl md:text-2xl"></i>
            今すぐ注文を始める
          </a>
        </div>
      </div>
    </section>
  );
}
